import type { LeadRecord, LeadStore } from "./types.js";

/** Reference implementation used for tests/local dev only - not for production use. */
export class InMemoryLeadStore implements LeadStore {
  private leads = new Map<string, LeadRecord>();

  async save(lead: LeadRecord): Promise<void> {
    this.leads.set(lead.id, lead);
  }

  async getById(id: string): Promise<LeadRecord | undefined> {
    return this.leads.get(id);
  }

  async list(): Promise<LeadRecord[]> {
    return [...this.leads.values()];
  }

  async delete(id: string): Promise<void> {
    this.leads.delete(id);
  }
}
